/**
 * Navigates to a URL and preserves the scroll position.
 * @param url - The URL to navigate to
 */
export function navigateToUrl(url) {
    let currentState = history.state;
    if (typeof currentState !== 'object') {
        currentState = {};
    }
    const state = {
        ...currentState,
        scroll: {
            left: window.scrollX,
            top: window.scrollY,
        },
    };
    window.history.replaceState(state, '');
    window.location.assign(url);
}
//# sourceMappingURL=navigateToUrl.js.map